export const en = {
  // Navigation
  navigation: {
    whyChooseUs: "Why Dubai",
    marketGrowth: "Growth",
    dubaiVsBudapest: "Dubai vs Budapest",
    megaprojects: "Projects",
    ourEvent: "Our Event",
    startInvestment: "Let's start",
  },

  // Language Selector
  languageSelector: {
    title: "Language",
  },

  // Banner
  banner: {
    title: "Dubai",
    subtitle: "The World's Leading Real Estate Investment Center",
    description:
      "Premium real estate investment opportunities with zero tax, world-class security and exceptional lifestyle benefits.",
    cta: "Contact",
  },

  // Stats
  stats: {
    personalIncomeTax: "Personal Income Tax",
    sunnyDays: "Sunny Days",
    safestCity: "Safest City",
  },

  // Stats Section
  statsSection: {
    gdpGrowth: "GDP Growth 2025",
    annualPassengers: "Annual Passenger Count DXB",
    nonOilGdp: "Non-oil GDP Share",
    countryRanking: "Country Ranking",
  },

  // Investment Drivers
  investmentDrivers: {
    title: "Investment Drivers",
    description:
      "The top 5 factors that made Dubai the world's leading real estate investment destination between 2010-2025.",
    items: [
      {
        title: "Safety & Stability",
        description:
          "Top 5 safest cities worldwide, low crime index and stable political environment.",
      },
      {
        title: "Zero Tax Policy",
        description:
          "0% personal income tax, capital gains tax, inheritance tax and property tax - maximum profit retention.",
      },
      {
        title: "Political Neutrality",
        description:
          "Strict geopolitical neutrality, free capital movement and real estate purchase for all nationalities.",
      },
      {
        title: "Migration & Population",
        description:
          "200,000+ Russian-speaking expats, 4,000+ millionaires and Golden Visa program with 10-year residency.",
      },
    ],
  },

  // WhoWeAre
  whoWeAre: {
    subtitle: "About Us",
    title: "Sustainable cryptocurrency mining with green energy",
    description:
      "Realiste aims to elevate Dubai real estate investment to a new level while providing sustainable and transparent value to its partners. With our own Dubai property portfolio and premium location infrastructure, we ensure high returns while offering stable investment opportunities.",
    description2:
      "With continuously monitored container machines, real data-based ROI calculations and market-leading hardware, we ensure a transparent, understandable and predictable investment opportunity.",
  },

  // OurMission
  ourMission: {
    subtitle: "Our Mission",
    title: "Maximum efficiency and continuous operation",
    description:
      "Realiste aims to operate its investment portfolio sustainably using premium Dubai properties. We currently operate three own Dubai properties in Downtown Dubai, Dubai Marina and Palm Jumeirah. We conduct investments with premium location-based properties, which are luxury-equipped and fully optimized for high returns. The capital used for investment thus goes into premium properties, maximizing the returns.",
    description2:
      "Machine operation is guaranteed 24/7. Cooling, power supply, and hardware optimization ensure that we achieve the highest possible hash rate at stable cost levels. Up to 100 machines can operate simultaneously in one container. Our own team performs maintenance, monitoring and reporting.",
  },

  // WhyChooseUs
  whyChooseUs: {
    subtitle: "Why Choose Us",
    title: "Why Choose Dubai?",
    description:
      "Dubai offers unique advantages for real estate investors. Discover what makes this city the world's most outstanding investment destination.",
    items: [
      {
        title: "Outstanding Investment Return",
        description:
          "Dubai's real estate market offers an average annual return of 8-12% with stable value appreciation.",
      },
      {
        title: "International Business Hub",
        description:
          "The financial and commercial center of the Middle East with excellent business opportunities.",
      },
      {
        title: "Luxury Lifestyle",
        description:
          "World-class infrastructure, shopping centers, and entertainment options.",
      },
      {
        title: "Cultural Diversity",
        description:
          "200+ nationalities live peacefully in Dubai, an open and welcoming community.",
      },
      {
        title: "Tax Optimization",
        description:
          "0% personal income tax, 5% VAT, no capital gains tax on real estate.",
      },
      {
        title: "Strategic Location",
        description:
          "At the crossroads of Asia, Africa, and Europe, a 4-hour flight from 2 billion people.",
      },
    ],
  },

  // Technology
  technology: {
    subtitle: "Technology",
    bitcoin: {
      title: "Bitcoin Mining (BTC)",
      description:
        "Bitcoin is the world's first decentralized digital currency, launched in 2009. A maximum of 21 million units are available, ensuring a deflationary model. Today it is a globally accepted instrument – institutional investors, banks and countries are also active participants. Due to its liquidity and value retention, it has become a long-term savings vehicle.",
    },
    aleo: {
      title: "Aleo Mining",
      description:
        "Aleo is a next-generation blockchain that uses Zero-Knowledge Proof technology. It enables the execution of private smart contracts with complete encryption. The project is supported by Google Ventures and A16Z, and according to the market, it is one of the Layer 1 networks with the greatest growth potential.",
    },
    infrastructure: {
      title: "Infrastructure",
      items: [
        "Own solar parks – cost-optimized, independent operation",
        "Container-based machine deployment – climate-controlled, data center-level efficiency",
        "Antminer S19 Pro and equivalent machines",
        "Online monitoring, complete transparency",
      ],
    },
  },

  // Roadmap
  roadmap: {
    subtitle: "Market Growth Data",
    title: "Market Growth Data",
    items: [
      {
        year: "2010",
        title: "1.9M",
        points: ["+3%", "Infrastructure development"],
      },
      {
        year: "2014-15",
        title: "2.3M",
        points: ["+7%", "Impact of Arab Spring"],
      },
      {
        year: "2018",
        title: "3.0M",
        points: ["+2%", "Oil price volatility"],
      },
      {
        year: "2020",
        title: "3.3M",
        points: ["-4%", "Impact of COVID-19"],
      },
      {
        year: "2022",
        title: "3.6M",
        points: ["+22%", "Russo-Ukrainian War"],
      },
      {
        year: "2024",
        title: "3.8M",
        points: ["+16%", "Continuous migration"],
      },
    ],
  },

  // Roadmap Stats
  roadmapStats: {
    realEstateGrowth: "Real estate price growth 2022-2024",
    foreignInvestors: "Foreign real estate investors 2022",
    nonOilGdp: "Non-oil sector GDP share",
    airportPassengers: "DXB airport passenger count 2025",
  },

  // Project categories
  projectCategories: {
    megaprojectsSubtitle: "Dubai megaprojects",
    microInvestmentsTitle: "Micro-investments",
    microInvestmentsComingSoon: "Details coming soon",
    microInvestmentsSubtitle: "Fractional real estate investments",
    microInvestmentsDescription: "You can buy real estate with as little as HUF 100,000.",
  },

  // Megaprojects
  megaprojects: {
    subtitle: "UAE Vision 2031",
    title: "Megaprojects",
    description:
      "Transformative developments realized within the framework of UAE Vision 2031 and Dubai Economic Agenda (D33), which aim to double the economy.",
    items: [
      {
        title: "Masdar City",
        status: "Under Construction",
        location: "Abu Dhabi",
        year: "2030",
        description:
          "6 km² eco-city, renewable energy hub, zero-carbon development",
        category: "Sustainable City",
        cost: "22 billion USD",
      },
      {
        title: "MBR Solar Park",
        status: "In Progress",
        location: "Dubai",
        year: "2030",
        description: "5,000 MW solar power plant, world's largest such project",
        category: "Renewable Energy",
        cost: "14 billion USD",
      },
      {
        title: "Etihad Rail",
        status: "Final Phase",
        location: "UAE",
        year: "2024",
        description:
          "900 km railway network, freight transport from 2023, passenger transport from 2024",
        category: "Infrastructure",
        cost: "11 billion USD",
      },
      {
        title: "Wynn Al Marjan Island",
        status: "Under Construction",
        location: "Ras Al Khaimah",
        year: "2027",
        description: "Luxury resort, 1,542 rooms, first mainland casino",
        category: "Tourism & Entertainment",
        cost: "3.9 billion USD",
      },
      {
        title: "Stargate Al Data Centre",
        status: "Planning",
        location: "UAE",
        year: "2026",
        description: "10 square mile AI center, 5 GW capacity, 100k GPU",
        category: "Technology",
        cost: "100+ billion USD",
      },
      {
        title: "The Loop",
        status: "Concept",
        location: "Dubai",
        year: "TBD",
        description:
          "93 km climate-controlled pedestrian/cycling corridor, zero emissions",
        category: "Transportation",
        cost: "TBD",
      },
    ],
  },

  // Megaprojects Stats
  megaprojectsStats: {
    gdpTarget: "3 Trillion AED",
    gdpDescription: "UAE GDP target for 2031 (doubling)",
    projectsCount: "100 Projects",
    projectsDescription: "Doubling Dubai's economy within the D33 framework",
    completionYear: "2033",
    completionDescription: "Dubai Economic Agenda completion date",
  },

  // Famous Residents
  famousResidents: {
    subtitle: "World Stars",
    title: "Famous Residents",
    description:
      "World stars and influential personalities who have chosen Dubai as their home or investment destination.",
    items: [
      {
        name: "Pavel Durov",
        profession: "Founder of Telegram",
        status: "Dubai resident",
        quote: "I moved to Dubai, where Telegram's headquarters are located.",
        country: "Russia",
        category: "Tech",
      },
      {
        name: "Lindsay Lohan",
        profession: "Actress",
        status: "Dubai resident since 2014",
        quote: "Here I get the privacy, peace and security I need.",
        country: "USA",
        category: "Entertainment",
      },
      {
        name: "Shah Rukh Khan",
        profession: "Actor",
        status: "Property owner",
        quote: "Dubai is my second home... there's always something new here.",
        country: "India",
        category: "Bollywood",
      },
      {
        name: "Roger Federer",
        profession: "Tennis champion",
        status: "Property owner",
        quote:
          "Dubai is a good location, I don't regret choosing it as my base.",
        country: "Switzerland",
        category: "Sport",
      },
      {
        name: "Novak Djokovic",
        profession: "Tennis champion",
        status: "Frequent visitor",
        quote: "Dubai is the city of champions. I love it here.",
        country: "Serbia",
        category: "Sport",
      },
      {
        name: "Will Smith",
        profession: "Actor",
        status: "Frequent visitor",
        quote: "Dubai dreams like me – it suits my soul.",
        country: "USA",
        category: "Hollywood",
      },
      {
        name: "Cristiano Ronaldo",
        profession: "Footballer",
        status: "Frequent visitor",
        quote: "I love Dubai, its people and its culture.",
        country: "Portugal",
        category: "Sport",
      },
      {
        name: "Giorgio Armani",
        profession: "Fashion designer",
        status: "Investor",
        quote: "Nothing compares to the wonder of Dubai.",
        country: "Italy",
        category: "Fashion",
      },
      {
        name: "Gordon Ramsay",
        profession: "Chef",
        status: "Frequent visitor",
        quote: "Dubai's gastronomic scene is world-class.",
        country: "UK",
        category: "Gastronomy",
      },
      {
        name: "CZ (Changpeng Zhao)",
        profession: "Binance CEO",
        status: "Dubai resident",
        quote: "Dubai is at the forefront of cryptocurrencies.",
        country: "China",
        category: "Crypto",
      },
    ],
  },

  // Famous Residents Stats
  famousResidentsStats: {
    knownPersons: "Known person lives in Dubai",
    permanentResidents: "Permanent celebrity resident",
    nationalities: "Nationalities represented",
    expatRatio: "Expat population ratio",
  },

  // Dubai vs Budapest
  dubaiVsBudapest: {
    subtitle: "Comparison",
    title: "Dubai vs Budapest",
    description:
      "Comparison of investment opportunities and quality of life between the two cities",
    categories: {
      title: "Category",
      realEstate: "Real Estate Prices",
      investmentReturn: "Investment Return",
      taxation: "Taxation",
      qualityOfLife: "Quality of Life",
      transportation: "Transportation",
      futurePotential: "Future Potential",
    },
    dubai: {
      realEstate: {
        value: "€4,500-15,000/m²",
        description: "Luxury neighborhoods, tax-free ownership",
      },
      investmentReturn: {
        value: "6-10% annually",
        description: "Impact of Expo 2030, World Cup 2034",
      },
      taxation: {
        value: "0% personal income tax",
        description: "No property tax, inheritance tax",
      },
      qualityOfLife: {
        value: "High level",
        description: "300+ sunny days, safety",
      },
      transportation: {
        value: "Global hub",
        description: "Asia, Africa, Europe within 3 hours",
      },
      futurePotential: {
        value: "Exponential",
        description: "Artificial intelligence, space industry",
      },
    },
    budapest: {
      realEstate: {
        value: "€2,000-6,000/m²",
        description: "Downtown and Buda hills area",
      },
      investmentReturn: {
        value: "4-7% annually",
        description: "Stable European market, EU membership",
      },
      taxation: {
        value: "15-35% Personal Income Tax",
        description: "Property tax, inheritance fee",
      },
      qualityOfLife: {
        value: "Good quality",
        description: "European culture, thermal baths",
      },
      transportation: {
        value: "European center",
        description: "Direct flights to EU",
      },
      futurePotential: {
        value: "Stable growth",
        description: "Technological developments",
      },
    },
    summary: {
      dubai: {
        title: "Dubai advantages",
        advantages: [
          "Tax-free environment",
          "Higher returns",
          "Future megaprojects",
          "Global connectivity",
        ],
      },
      budapest: {
        title: "Budapest advantages",
        advantages: [
          "Lower entry threshold",
          "EU legal certainty",
          "Cultural proximity",
          "Stable market",
        ],
      },
    },
  },

  // Contact
  contact: {
    subtitle: "Start Your Dubai Investment",
    title: "Start Your Dubai Investment",
    description:
      "Our expert team helps you find the perfect investment opportunity in Dubai's dynamic real estate market. Contact us today!",
    email: {
      title: "Email Contact",
      description: "Write to us with your detailed questions",
      address: "hello@dubaiingatlan.ai",
    },
    phone: {
      title: "Phone Consultation",
      description: "Let's talk personally about the opportunities",
      number: "+36 30 655 6554",
    },
    booking: {
      title: "Online consultation",
      description: "Request a 30-minute online meeting from the available slots",
      action: "Request a time",
      close: "Close booking",
      loading: "Loading available times...",
      note: "Choose a time. We will receive your request by email. Your meeting is confirmed only after our reply.",
      slot: "Available times (Budapest time)",
      choose: "Choose a time",
      name: "Name",
      email: "Email address",
      phone: "Phone number",
      request: "Send meeting request",
      sending: "Sending...",
      sent: "Your meeting request has been sent. The meeting is confirmed only after our reply.",
      taken: "This time is no longer available. Please choose another.",
      error: "The request cannot be sent right now. Please try again later.",
    },
    form: {
      name: "Enter your name",
      email: "Enter your email address",
      message: "Enter your message",
      submit: "Send Message",
    },
  },

  // Event
  event: {
    title: "Dubai Real Estate Investments and Everything Behind It",
    subtitle:
      "Inside Dubai Real Estate: The Money, Myths & Million-Dollar Moves",
    mainTitle: "Dubai Real Estate — The Truth Behind the Hype",
    date: "September 17, Thursday",
    time: "4:00 PM",
    location: "Breitling Boutique 1061 Budapest Andrássy út 14",
    description: {
      title: "Event Details",
      text: "Join our exclusive closed (free) event at Al Habtoor Palace Budapest. September 17 in the afternoon. 4:00 PM",
    },
    learn: {
      title: "Learn:",
      item1:
        "Whether buying real estate in Dubai is truly worth it — and when it's not.",
      item2: "What to consider before investing internationally.",
      item3: "How to spot red flags and avoid costly pitfalls.",
    },
    plus: {
      title: "Plus:",
      item1:
        "Get an objective view of the entire Dubai market — not just a few developer offers.",
      item2:
        "Discover Realiste.ai, the world's first AI that guides you through every step of buying property in Dubai.",
      item3: "Ask your questions and get real, data-driven answers.",
    },
    guest: {
      title: "About Alex Galt:",
      description:
        "Alex Galt is the founder of Realiste.ai and Titleman.ai, cutting-edge AI-powered platform that help users navigate real estate investing and property acquisition. With an asserted track record of $300 million in sales across 600 property deals, Alex brings both hands-on experience and technological innovation to the world of real estate.",
    },
    whyDifferent: {
      title: "🌟 Why This Event Is Different",
      description:
        "This isn't another \"sales\" seminar or developer showcase — it's a data-driven, no-bias deep dive into the real Dubai property market. You'll discover where the smart money is moving, what mistakes even seasoned investors make, and how to spot deals that can double your capital in 3–5 years.\n\nYou won't hear pitches — you'll see AI analytics, live market heatmaps, and real case studies from investors who built 7-figure portfolios using technology instead of guesswork.\n\nAnd you'll meet Alex Galt, founder of Realiste.ai and Titleman.ai — platforms behind over $300M in analyzed transactions — sharing insider insights you won't find at any other event.",
    },
    whyInvestors: {
      title: "💰 Why Investors Use Realiste.ai",
      items: [
        {
          title: "Find Hidden Opportunities Instantly",
          description:
            "Realiste's AI scans the entire Dubai real estate market — not just developer listings — to identify undervalued properties and high-ROI investment opportunities. It ranks projects by metrics like expected appreciation, rental yield, and price-to-market gap, helping investors find deals that can double in 3–5 years.",
        },
        {
          title: "Objective, Data-Driven Decisions",
          description:
            "Instead of relying on agents' opinions or marketing promises, investors get real-time market data sourced from hundreds of verified channels (DLD, Bayut, Property Finder, etc.). The AI compares every project in the city, showing where the real profits are — objectively and instantly.",
        },
        {
          title: "Portfolio Optimization & Forecasts",
          description:
            "Investors can see how each property performs over time — projected ROI, rent growth, and resale potential. This allows them to build balanced portfolios: cash-flowing units, appreciation bets, and stable long-term holds, all powered by data instead of guesswork.",
        },
        {
          title: "No Agent Pressure, No Hidden Bias",
          description:
            "Realiste acts as your independent advisor, not a broker with a limited inventory. It shows the entire market, with full transparency — including units that brokers don't push because they pay smaller commissions.",
        },
        {
          title: "Speed & Execution",
          description:
            "Investors can reserve, verify, and close deals faster — often within 24–72 hours — through Realiste's integrated network of developers, banks, and legal partners. Everything from due diligence to contracts is supported digitally.",
        },
        {
          title: 'Access to Exclusive "AI Picks"',
          description:
            "The system highlights the top 1% of investment-grade properties each week — those with the strongest fundamentals and lowest risk. Many investors use these insights to act before projects trend publicly.",
        },
        {
          title: "Global Expansion & Diversification",
          description:
            "Beyond Dubai, Realiste is expanding across 132+ cities worldwide, giving investors a single platform to track, compare, and buy international properties with consistent analytics and legal support.",
        },
      ],
    },
    registration: {
      title: "Registration",
      note: "Participation is free but requires registration.",
      form: {
        name: "Name",
        namePlaceholder: "Enter your name",
        email: "Email Address",
        emailPlaceholder: "Enter your email address",
        phone: "Phone Number",
        phonePlaceholder: "Enter your phone number",
        consultationMode: "Consultation mode",
        consultationModePlaceholder: "Select consultation mode",
        consultationModeInPerson: "In person",
        consultationModeOnline: "On-line",
        message: "Message (optional)",
        messagePlaceholder: "Write a message...",
        submit: "Register",
        submitting: "Registering...",
      },
      successMessage: "Successful registration! We will contact you soon.",
      errorMessage: "An error occurred during registration. Please try again.",
    },
  },

  thankYou: {
    title: "Thank you for registering!",
    description:
      "We have successfully received the form. We will contact you soon.",
    button: "Back to homepage",
  },

  // Footer
  footer: {
    description:
      "Realiste conducts sustainable real estate investment with premium locations and own Dubai property portfolio. We offer transparent, predictable investment opportunities with real infrastructure and market-leading technology.",
    navigation: "Navigation",
    copyright: "Copyright © 2025. All rights reserved Realiste",
    terms: "Terms and Services",
    privacy: "Privacy Policy",
  },
};
